// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/task/v1/binding.proto" (package "c1.api.task.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../../../../google/protobuf/timestamp";
import { Any } from "../../../../google/protobuf/any";
import { TaskView } from "./task";
import { TaskExpandMask } from "./task";
/**
 * @generated from protobuf message c1.api.task.v1.ListRelatedTasksRequest
 */
export interface ListRelatedTasksRequest {
    /**
     * @generated from protobuf field: string reference_task_id = 1
     */
    referenceTaskId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskExpandMask expand_mask = 4
     */
    expandMask?: TaskExpandMask;
}
/**
 * @generated from protobuf message c1.api.task.v1.ListRelatedTasksResponse
 */
export interface ListRelatedTasksResponse {
    /**
     * @generated from protobuf field: repeated c1.api.task.v1.TaskView list = 1
     */
    list: TaskView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.CountRelatedTasksRequest
 */
export interface CountRelatedTasksRequest {
    /**
     * @generated from protobuf field: string reference_task_id = 1
     */
    referenceTaskId: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.CountRelatedTasksResponse
 */
export interface CountRelatedTasksResponse {
    /**
     * @generated from protobuf field: int64 count = 1
     */
    count: number;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskBindingServiceListRequest
 */
export interface TaskBindingServiceListRequest {
    /**
     * @generated from protobuf field: string task_id = 1
     */
    taskId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskExpandMask expand_mask = 4
     */
    expandMask?: TaskExpandMask;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskBindingServiceListByReferenceTaskRequest
 */
export interface TaskBindingServiceListByReferenceTaskRequest {
    /**
     * @generated from protobuf field: string reference_task_id = 1
     */
    referenceTaskId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskExpandMask expand_mask = 4
     */
    expandMask?: TaskExpandMask;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskBinding
 */
export interface TaskBinding {
    /**
     * @generated from protobuf field: string tenant_id = 1
     */
    tenantId: string;
    /**
     * @generated from protobuf field: string id = 2
     */
    id: string;
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskView task = 3
     */
    task?: TaskView;
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskView referenced_task = 4
     */
    referencedTask?: TaskView;
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskRelationship relationship = 5
     */
    relationship: TaskRelationship;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 6
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 7
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 8
     */
    deletedAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskBindingView
 */
export interface TaskBindingView {
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskBinding item = 1
     */
    item?: TaskBinding;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskBindingServiceListResponse
 */
export interface TaskBindingServiceListResponse {
    /**
     * @generated from protobuf field: repeated c1.api.task.v1.TaskBindingView list = 1
     */
    list: TaskBindingView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf enum c1.api.task.v1.TaskRelationship
 */
export enum TaskRelationship {
    /**
     * @generated from protobuf enum value: TASK_RELATIONSHIP_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: TASK_RELATIONSHIP_CREATED_TASK = 1;
     */
    CREATED_TASK = 1,
    /**
     * @generated from protobuf enum value: TASK_RELATIONSHIP_CREATED_BY_TASK = 2;
     */
    CREATED_BY_TASK = 2,
    /**
     * @generated from protobuf enum value: TASK_RELATIONSHIP_SUPERSEDED_BY = 3;
     */
    SUPERSEDED_BY = 3
}
// @generated message type with reflection information, may provide speed optimized methods
class ListRelatedTasksRequest$Type extends MessageType<ListRelatedTasksRequest> {
    constructor() {
        super("c1.api.task.v1.ListRelatedTasksRequest", [
            { no: 1, name: "reference_task_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => TaskExpandMask }
        ]);
    }
    create(value?: PartialMessage<ListRelatedTasksRequest>): ListRelatedTasksRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.referenceTaskId = "";
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ListRelatedTasksRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListRelatedTasksRequest): ListRelatedTasksRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string reference_task_id */ 1:
                    message.referenceTaskId = reader.string();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                case /* c1.api.task.v1.TaskExpandMask expand_mask */ 4:
                    message.expandMask = TaskExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListRelatedTasksRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string reference_task_id = 1; */
        if (message.referenceTaskId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.referenceTaskId);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        /* c1.api.task.v1.TaskExpandMask expand_mask = 4; */
        if (message.expandMask)
            TaskExpandMask.internalBinaryWrite(message.expandMask, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.ListRelatedTasksRequest
 */
export const ListRelatedTasksRequest = new ListRelatedTasksRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListRelatedTasksResponse$Type extends MessageType<ListRelatedTasksResponse> {
    constructor() {
        super("c1.api.task.v1.ListRelatedTasksResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TaskView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ListRelatedTasksResponse>): ListRelatedTasksResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.expanded = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ListRelatedTasksResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListRelatedTasksResponse): ListRelatedTasksResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.task.v1.TaskView list */ 1:
                    message.list.push(TaskView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 3:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListRelatedTasksResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.task.v1.TaskView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            TaskView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 3; */
        if (message.nextPageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.ListRelatedTasksResponse
 */
export const ListRelatedTasksResponse = new ListRelatedTasksResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CountRelatedTasksRequest$Type extends MessageType<CountRelatedTasksRequest> {
    constructor() {
        super("c1.api.task.v1.CountRelatedTasksRequest", [
            { no: 1, name: "reference_task_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } }
        ]);
    }
    create(value?: PartialMessage<CountRelatedTasksRequest>): CountRelatedTasksRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.referenceTaskId = "";
        if (value !== undefined)
            reflectionMergePartial<CountRelatedTasksRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CountRelatedTasksRequest): CountRelatedTasksRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string reference_task_id */ 1:
                    message.referenceTaskId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CountRelatedTasksRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string reference_task_id = 1; */
        if (message.referenceTaskId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.referenceTaskId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.CountRelatedTasksRequest
 */
export const CountRelatedTasksRequest = new CountRelatedTasksRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CountRelatedTasksResponse$Type extends MessageType<CountRelatedTasksResponse> {
    constructor() {
        super("c1.api.task.v1.CountRelatedTasksResponse", [
            { no: 1, name: "count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<CountRelatedTasksResponse>): CountRelatedTasksResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.count = 0;
        if (value !== undefined)
            reflectionMergePartial<CountRelatedTasksResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CountRelatedTasksResponse): CountRelatedTasksResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 count */ 1:
                    message.count = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CountRelatedTasksResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 count = 1; */
        if (message.count !== 0)
            writer.tag(1, WireType.Varint).int64(message.count);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.CountRelatedTasksResponse
 */
export const CountRelatedTasksResponse = new CountRelatedTasksResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskBindingServiceListRequest$Type extends MessageType<TaskBindingServiceListRequest> {
    constructor() {
        super("c1.api.task.v1.TaskBindingServiceListRequest", [
            { no: 1, name: "task_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => TaskExpandMask }
        ]);
    }
    create(value?: PartialMessage<TaskBindingServiceListRequest>): TaskBindingServiceListRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.taskId = "";
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<TaskBindingServiceListRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskBindingServiceListRequest): TaskBindingServiceListRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string task_id */ 1:
                    message.taskId = reader.string();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                case /* c1.api.task.v1.TaskExpandMask expand_mask */ 4:
                    message.expandMask = TaskExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskBindingServiceListRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string task_id = 1; */
        if (message.taskId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.taskId);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        /* c1.api.task.v1.TaskExpandMask expand_mask = 4; */
        if (message.expandMask)
            TaskExpandMask.internalBinaryWrite(message.expandMask, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskBindingServiceListRequest
 */
export const TaskBindingServiceListRequest = new TaskBindingServiceListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskBindingServiceListByReferenceTaskRequest$Type extends MessageType<TaskBindingServiceListByReferenceTaskRequest> {
    constructor() {
        super("c1.api.task.v1.TaskBindingServiceListByReferenceTaskRequest", [
            { no: 1, name: "reference_task_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => TaskExpandMask }
        ]);
    }
    create(value?: PartialMessage<TaskBindingServiceListByReferenceTaskRequest>): TaskBindingServiceListByReferenceTaskRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.referenceTaskId = "";
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<TaskBindingServiceListByReferenceTaskRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskBindingServiceListByReferenceTaskRequest): TaskBindingServiceListByReferenceTaskRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string reference_task_id */ 1:
                    message.referenceTaskId = reader.string();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                case /* c1.api.task.v1.TaskExpandMask expand_mask */ 4:
                    message.expandMask = TaskExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskBindingServiceListByReferenceTaskRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string reference_task_id = 1; */
        if (message.referenceTaskId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.referenceTaskId);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        /* c1.api.task.v1.TaskExpandMask expand_mask = 4; */
        if (message.expandMask)
            TaskExpandMask.internalBinaryWrite(message.expandMask, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskBindingServiceListByReferenceTaskRequest
 */
export const TaskBindingServiceListByReferenceTaskRequest = new TaskBindingServiceListByReferenceTaskRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskBinding$Type extends MessageType<TaskBinding> {
    constructor() {
        super("c1.api.task.v1.TaskBinding", [
            { no: 1, name: "tenant_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "task", kind: "message", T: () => TaskView },
            { no: 4, name: "referenced_task", kind: "message", T: () => TaskView },
            { no: 5, name: "relationship", kind: "enum", T: () => ["c1.api.task.v1.TaskRelationship", TaskRelationship, "TASK_RELATIONSHIP_"] },
            { no: 6, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 7, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 8, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
    create(value?: PartialMessage<TaskBinding>): TaskBinding {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tenantId = "";
        message.id = "";
        message.relationship = 0;
        if (value !== undefined)
            reflectionMergePartial<TaskBinding>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskBinding): TaskBinding {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string tenant_id */ 1:
                    message.tenantId = reader.string();
                    break;
                case /* string id */ 2:
                    message.id = reader.string();
                    break;
                case /* c1.api.task.v1.TaskView task */ 3:
                    message.task = TaskView.internalBinaryRead(reader, reader.uint32(), options, message.task);
                    break;
                case /* c1.api.task.v1.TaskView referenced_task */ 4:
                    message.referencedTask = TaskView.internalBinaryRead(reader, reader.uint32(), options, message.referencedTask);
                    break;
                case /* c1.api.task.v1.TaskRelationship relationship */ 5:
                    message.relationship = reader.int32();
                    break;
                case /* google.protobuf.Timestamp created_at */ 6:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 7:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp deleted_at */ 8:
                    message.deletedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deletedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskBinding, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string tenant_id = 1; */
        if (message.tenantId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.tenantId);
        /* string id = 2; */
        if (message.id !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.id);
        /* c1.api.task.v1.TaskView task = 3; */
        if (message.task)
            TaskView.internalBinaryWrite(message.task, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskView referenced_task = 4; */
        if (message.referencedTask)
            TaskView.internalBinaryWrite(message.referencedTask, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskRelationship relationship = 5; */
        if (message.relationship !== 0)
            writer.tag(5, WireType.Varint).int32(message.relationship);
        /* google.protobuf.Timestamp created_at = 6; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 7; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp deleted_at = 8; */
        if (message.deletedAt)
            Timestamp.internalBinaryWrite(message.deletedAt, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskBinding
 */
export const TaskBinding = new TaskBinding$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskBindingView$Type extends MessageType<TaskBindingView> {
    constructor() {
        super("c1.api.task.v1.TaskBindingView", [
            { no: 1, name: "item", kind: "message", T: () => TaskBinding }
        ]);
    }
    create(value?: PartialMessage<TaskBindingView>): TaskBindingView {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<TaskBindingView>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskBindingView): TaskBindingView {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.task.v1.TaskBinding item */ 1:
                    message.item = TaskBinding.internalBinaryRead(reader, reader.uint32(), options, message.item);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskBindingView, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.task.v1.TaskBinding item = 1; */
        if (message.item)
            TaskBinding.internalBinaryWrite(message.item, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskBindingView
 */
export const TaskBindingView = new TaskBindingView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskBindingServiceListResponse$Type extends MessageType<TaskBindingServiceListResponse> {
    constructor() {
        super("c1.api.task.v1.TaskBindingServiceListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TaskBindingView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TaskBindingServiceListResponse>): TaskBindingServiceListResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.expanded = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<TaskBindingServiceListResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskBindingServiceListResponse): TaskBindingServiceListResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.task.v1.TaskBindingView list */ 1:
                    message.list.push(TaskBindingView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 3:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskBindingServiceListResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.task.v1.TaskBindingView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            TaskBindingView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 3; */
        if (message.nextPageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskBindingServiceListResponse
 */
export const TaskBindingServiceListResponse = new TaskBindingServiceListResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.task.v1.TaskBindingService
 */
export const TaskBindingService = new ServiceType("c1.api.task.v1.TaskBindingService", [
    { name: "List", options: { "authz.method": { role: "VIEWER" } }, I: TaskBindingServiceListRequest, O: TaskBindingServiceListResponse },
    { name: "ListByReferenceTask", options: { "authz.method": { role: "VIEWER" } }, I: TaskBindingServiceListByReferenceTaskRequest, O: TaskBindingServiceListResponse },
    { name: "ListRelatedTasks", options: { "authz.method": { role: "VIEWER" } }, I: ListRelatedTasksRequest, O: ListRelatedTasksResponse },
    { name: "CountRelatedTasks", options: { "authz.method": { role: "VIEWER" } }, I: CountRelatedTasksRequest, O: CountRelatedTasksResponse }
]);
